import React from 'react'
import {Set} from 'immutable'

export const withSelect = (Component) => {
  return class WithSelect extends React.Component {
    state = {
      selectedItems: Set()
    }

    clearSelection = () => {
      this.setState({selectedItems: Set()})
    }

    selectItem = (item) => {
      this.setState((state) => ({
        selectedItems: state.selectedItems.add(item)
      }))
    }

    selectItems = (items) => {
      this.setState((state) => ({
        selectedItems: state.selectedItems.concat(items)
      }))
    }

    deselectItem = (item) => {
      this.setState((state) => ({
        selectedItems: state.selectedItems.delete(item)
      }))
    }

    render () {
      const {selectedItems} = this.state

      return <Component
        {...this.props}
        selectedItems={selectedItems}
        clearSelection={this.clearSelection}
        selectItem={this.selectItem}
        selectItems={this.selectItems}
        deselectItem={this.deselectItem}
      />
    }
  }
}
